import {
  sendLoginData,
  sendRegistrationDataApiCall,
  getUserData,
  usernameRecovery,
  wsSend
} from "../api";
import { getRolesForLoggedInUser } from "../../utils/api";
import axios from "axios";

export const actions = {
  sendLoginData({ commit }, loginData) {
    // API
    return new Promise((resolve, reject) => {
      sendLoginData(loginData)
        .then(res => {
          const data = res.data.token;
          sessionStorage.setItem("token", res.data.token);

          commit("SET_TOKEN", data);
          axios.defaults.headers.common[
            "Authorization"
          ] = `JWT ${res.data.token}`;
          getRolesForLoggedInUser().then(res => {
            sessionStorage.setItem("userRoles", JSON.stringify(res));
            commit("SET_ROLES", res?.role);
          });
          getUserData(loginData).then(userData => {
            sessionStorage.setItem("userData", JSON.stringify(userData));
            commit("SET_USER", userData);

            // wsSend();  WebSockets are commented out.
          });

          resolve();
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  sendRegistrationData({ commit }, registrationData) {
    sendRegistrationDataApiCall(registrationData);
  },
  refreshToken({ commit }, axios) {
    this.refreshToken(axios).then(data => {
      commit("SET_TOKEN", data);
    });
  },
  getUserData({ commit }, payload) {
    getUserData(payload).then(userData => {
      commit("SET_USER", userData);
    });
  },
  logoutUser({ commit, state }) {
    return new Promise(resolve => {
      sessionStorage.clear();
      commit("RESET_ALL_RECORDS");
      commit("LOGOUT_USER");
      commit("SET_TOKEN", null);
      commit("SET_ROLES", []);
      resolve();
    });
  },
  usernameRecovery({ commit }, email) {
    usernameRecovery(email);
  }
};
